<template>
  <div class="md-layout" :class="{ isEditing: 'edit' == formConfig.pageMode }">
    <!-- Begin: Sidepanel -->
    <div class="_portalRoot">
      <portal to="sidepanel-portal-dependents">

        <!-- Parent Product Option section -->
        <!-- <DynamoList :list.sync="productParentList" :filter="productChildIdFilter" ref="productParentListRef"></DynamoList> -->
        <ElasticList
          :list.sync="productParentList"
          :filter="productChildIdFilter"
          ref="productParentListRef"
        ></ElasticList>

        <md-dialog :md-active.sync="productParentList.showRelatedDialog">	
          <md-dialog-title>{{relateProductParentList.pageTitle}}</md-dialog-title>	

          <md-dialog-content>	
            <ElasticList	
              v-if="recordData"	
              :list.sync="relateProductParentList"	
              :filter="relateParentProductFilter"
              :relateRecordInput="newRecordInputParent"
              :relateRecordInputField="relateProductParentList.relateRecordInputField"
              :relateRecordInputParentId="relateProductParentList.relateRecordInputParentId"
            ></ElasticList>	
          </md-dialog-content>

          <md-dialog-actions>	
            <md-button class="md-theme-default" @click="productParentList.showRelatedDialog = false;">Close</md-button>	
          </md-dialog-actions>
        </md-dialog>

        <!-- Dependencies/Child Product Option section -->
        <!-- <DynamoList :list.sync="productChildList" ref="productChildListRef"></DynamoList> -->
        <ElasticList
          :list.sync="productChildList"
          :filter="productParentIdFilter"
          ref="productChildListRef"
        ></ElasticList>

        <md-dialog :md-active.sync="productChildList.showRelatedDialog">	
          <md-dialog-title>{{relateProductChildList.pageTitle}}</md-dialog-title>	
          	
          <md-dialog-content>	
            <ElasticList	
              v-if="recordData"	
              :filter="relateChildProductFilter"
              :list.sync="relateProductChildList"	
              :relateRecordInput="newRecordInputChild"
              :relateRecordInputField="relateProductChildList.relateRecordInputField"
            ></ElasticList>	
          </md-dialog-content>

          <md-dialog-actions>	
            <md-button class="md-theme-default" @click="productChildList.showRelatedDialog = false;">Close</md-button>	
          </md-dialog-actions>	
        </md-dialog>

        <!-- Dependencies - Add new "Product Option to Account" as Product -->
        <md-dialog class="__customize" :md-active.sync="productChildList.showAddNewModal">
          <md-dialog-title>Add Product</md-dialog-title>
          <md-dialog-content>
            <AddProductModal
              :productsList.sync="productChildList"
              :productAccountId="form.productAccountId"
              productAccountAlert=""
              :loadProductOptions ="loadProductOptions"
              :selectDefaultCategory="form.category"
            ></AddProductModal>
          </md-dialog-content>
        </md-dialog>

      </portal>
    </div>
    <!-- End: Sidepanel -->

    <div v-if="$route.params.id" id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{formConfig.headerIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color content-wrap">{{recordData? recordData.name : ''}}</h1>
      </div>
    </div>
    <template
      v-if="$route.params.id">
      <md-tabs md-sync-route class="topNavTabs">

        <md-tab id="tab-account" md-label="Product" :to="recordPath" exact>
          <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor" :filter="serviceAccountIdFilter"></ConfigForm>
        </md-tab>

<!--        <md-tab id="tab-extra" md-label="Extra" :to="recordPath + '/extra'">-->
<!--        </md-tab>-->
<!--        <md-tab id="tab-other" md-label="Other" :to="recordPath + '/other'">-->
<!--        </md-tab>-->

        <!-- Case tab -->
        <md-tab id="tab-cases" md-label="Cases" :to="recordPath + '/cases'">
          <CaseTab
            v-if="$route && $route.meta.tab === 'cases'" 
            :routeParamsId= "$route.params.id" 
            :caseListData= "casesList"
            :caseMapFilter="caseProductIdFilter"
            :caseServiceRelateRecordInput="caseServiceRelateRecordInput"
          />
        </md-tab>
        <!-- Task tab -->
        <md-tab id="tab-tasks" md-label="Tasks" :to="recordPath + '/tasks'">
          <TaskTab
            v-if="$route && $route.meta.tab === 'tasks'" 
            :routeParamsId= "$route.params.id" 
            :taskListData= "tasksList"
            :filter="taskProductIdFilter"
          />
        </md-tab>
      </md-tabs>
    </template>

    <div v-else class="md-layout-item md-small-size-100">
      <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor" :filter="serviceAccountIdFilter"></ConfigForm>
    </div>

  </div>
</template>

<script>
  import Record from '@/mixins/Record';
  import Amplify, { API, graphqlOperation } from 'aws-amplify';
  import * as queries_custom from "@/graphql/queries_custom";
  import * as queries from "@/graphql/queries";

  // Form validations
  import { required, numeric, minLength } from "vuelidate/lib/validators";
  import CaseTab from '@/components/CaseTab';
  import TaskTab from '@/components/TaskTab';
  import AddProductModal from '@/pages/Products/AddProductModal';

  export default {
    name: "product",
    mixins: [Record],
    components: {
      CaseTab,
      TaskTab,
      AddProductModal
    },
    computed: {
      caseServiceRelateRecordInput: function() { return {'caseProductCaseId': null, 'caseProductProductId': this.$route.params.id}},
      caseProductIdFilter: function() { return {"match": {"caseProductProductId": this.$route.params.id }}; },
      serviceAccountIdFilter: function () { return [{"match": {"serviceAccountId.keyword": this.form.productAccountId }}] },
      //taskProductIdFilter: function() { return {"taskProductProductId": {"eq": this.$route.params.id }}; },
      taskProductIdFilter: function() { return {"match": {"taskProductProductId": this.$route.params.id }}; },
      //productChildIdFilter: function() { return {"productChildChildId": {"eq": this.$route.params.id}}; },
      productChildIdFilter: function() {
        return { match: { productChildChildId: this.$route.params.id } };
      },
      productParentIdFilter: function() {
        return { match: { parentId: this.$route.params.id } };
      },
      relateChildProductFilter: function() {
        const mustIds = [];
        const mustNotIds = [];
        const filter = {};

        //Match multiple IDs
        this.productChildList.includeProductOptions.forEach(_id => {
          mustIds.push({ match_phrase: { productProductOptionId: _id } });
        });
        //exclude IDs
        this.productChildList.skipProductChilds.forEach(_id => {
          mustNotIds.push({ match_phrase: { id: _id } });
        });
        //if match IDs exist
        if (mustIds.length) {
          filter.must = [
            { bool: { should: mustIds } }
          ];
        }
        //if exclude IDs exist
        if (mustNotIds.length) {
          filter.must_not = [
            { bool: { should: mustNotIds } }
          ]
        }

        if (Object.keys(filter).length === 0) {
          return;
        }

        return {
          bool: filter
        }
      },
      /**
       * ATLAS-1012: <Product/Product Option> <Side Panel> Product Dependencies
       * Filter Product records with productAccountId
       * 
       * ATLAS-1310: Product details -> Sidepanel -> Parent section Link popup
       */
      relateParentProductFilter: function () {
        if (!this.productParentList.must || this.productParentList.must.length == 0) return;

        let mustIds = [];
        let mustNotIds = [];
        let filter = {};

        this.productParentList.must.forEach(el => {
          const map = {};
          map[el.name] = el.value;
          mustIds.push({match_phrase: map});
        });
        //exclude already added Product dependencies in Add dialog
        this.productParentList.skipProductParents.forEach(_id => {
          mustNotIds.push({ match_phrase: { id: _id } });
        });
        //exlude current product too
        mustNotIds.push({ match_phrase: { id: this.$route.params.id } });
        //if match ID exist
        if (mustIds.length) {
          filter.must = mustIds;
        }
        //if exclude IDs exist
        if (mustNotIds.length) {
          filter.must_not = mustNotIds;
        }
        if (Object.keys(filter).length === 0) {
          return;
        }
        return {
          bool: filter
        }
      },
      newRecordInputParent: function () {
        let input = this.relateProductParentList.relateRecordInput;
        let routeField = this.relateProductParentList.relateRecordRouteField;
        input[routeField] = this.$route.params.id;
        return input;
      },
      newRecordInputChild: function () {
        let input = this.relateProductChildList.relateRecordInput;
        let routeField = this.relateProductChildList.relateRecordRouteField;
        input[routeField] = this.$route.params.id;
        return input;
      }
    },
        
    data() {
      return {
        autocompleteAccountsList: [],
        autocompleteProductOptionsList: [],
        formConfig: {
          hasUpdatedBy: true,
          updatedByFieldName: 'productUpdatedById',
          responseFieldName: 'getProduct',
          removeFields: ['services','children'],
          actions: {
            save: 'createProduct',
            view: 'getProduct',
            edit: 'editProduct',
            new: 'newProduct',
            update: 'updateProduct',
            delete: 'deleteProduct',
          },
          slots: {
            basic: {label: 'Basic Information', icon: 'work', layout: {"x":0,"y":0,"w":12,"h":12,"i":"0"}, id: "BasicInformation"},
            features: {label: 'Features', icon: 'work', layout: {"x":0,"y":12,"w":12,"h":12,"i":"1"}, id: "Features"},

            equipment: {label: 'Equipment', icon: 'work', layout: {"x":0,"y":24,"w":12,"h":12,"i":"2"}, id: "Equipment"},
            file_build_info: {label: 'File Build Info', icon: 'work', layout: {"x":0,"y":36,"w":12,"h":12,"i":"3"}, id: "FileBuildInfo"},

            static_info: {label: 'Static Information', icon: 'work', layout: {"x":0,"y":48,"w":12,"h":12,"i":"4"}, id: "StaticInformation"},
            download_info: {label: 'Download Information', icon: 'work', layout: {"x":0,"y":60,"w":12,"h":12,"i":"5"}, id: "DownloadInformation"},
          },
          listPath: "/products",
          headerIcon: 'devices',
          objectName: 'Product',
          objectNamePlural: 'Products',
          editMode: false,
          removeField: "category",  // can be remove the form field
          pageMode: 'new', // can be one of ['new', 'view' 'edit']
          fields: {
            id: { label: "ID", type: "id", slot: 'basic' },
            name: { label: "Product Alias", type: "text", slot: 'basic' },
            category: { label: "Product Category", type: "select", slot: 'basic', options: [], optionType: 'enum' },
            platform: { label: "Platform", type: "select", slot: 'basic', options: [], optionType: 'enum' },
            productProductOptionId: { label: "Product Option", type: "autocomplete", slot: 'basic',
              data: [],
              searchTerm: "",
              options: [],
              linkBase: '#/productoptions/',
              setVal: (val) => {
                this.$v.form.productProductOptionId.$model = val;
              },
              select: (c) => {(($this) => {
                $this.setVal(c.id);
                $this.searchTerm = c.name;
              })(this.formConfig.fields.productProductOptionId)},
              isLazyLoadEnabled: true,
              lazyLoadListQueryId: 'searchProductOptions',
              lazyLoadResponseFieldName: 'searchProductOptions',
              lazyLoadSearchableFields: ['name'],
              lazyLoadFilter: null,
              hide: () => {
                return (!this.form || !this.form.category);
              },
            },
            cashDiscount: { label: "Cash Discount Program", type: "checkbox", slot: 'basic' },
            productAccountId: { label: "Account", type: "autocomplete", slot: 'basic',
              data: [],
              searchTerm: "",
              options: [],
              linkBase: '#/accounts/',
              setVal: (val) => {
                this.$v.form.productAccountId.$model = val;
              },
              select: (c) => {(($this) => {
                $this.setVal(c.id);
                $this.searchTerm = c.name;
              })(this.formConfig.fields.productAccountId)},
              isLazyLoadEnabled: true,
              lazyLoadListQueryId: 'searchAccounts',
              lazyLoadResponseFieldName: 'searchAccounts',
              lazyLoadSearchableFields: ['name'],
            },
            description: { label: "Description", type: "textarea", slot: 'basic' },
            productBillToServiceId: { label: "Bill To Service", type: "autocomplete", slot: 'basic',
              data: [],
              searchTerm: "",
              options: [],
              linkBase: '#/services/',
              setVal: (val) => {
                this.$v.form.productBillToServiceId.$model = val;
              },
              select: (c) => {(($this) => {
                $this.setVal(c.id);
                $this.searchTerm = c.name;
              })(this.formConfig.fields.productBillToServiceId)},
              isLazyLoadEnabled: true,
              lazyLoadListQueryId: 'searchServices',
              lazyLoadResponseFieldName: 'searchServices',
              lazyLoadSearchableFields: ['name'],
              lazyLoadFilter: null,
              // change: (search) => {(($this) => {
              //   let arrData = [];
              //   $this.data.filter(_item => {
              //     if(_item.account && _item.account.id === this.form.productAccountId ){
              //       arrData.push(_item)
              //     }
              //   });
              //   const data = arrData;
              //   $this.options = new Promise(resolve => {
              //     window.setTimeout(() => {
              //       if (!search) {
              //         $this.setVal("");
              //         $this.searchTerm = "";
              //         resolve(data)
              //       } else {
              //         const term = search.toLowerCase();
              //         let result = data.filter(({ name }) => name.toLowerCase() === term);
              //         if (result.length) {
              //           $this.select(result[0]);
              //         } else {
              //           $this.setVal("");
              //           $this.searchTerm = "";
              //         }
              //         resolve(data.filter(({ name }) => name.toLowerCase().includes(term)));
              //       }
              //     }, 100)
              //   })
              // })(this.formConfig.fields.productBillToServiceId)}
              
            },
            owner: { label: "Created By", type: "text", slot: 'basic', preventEdit: true },
            services: {
              label: "Services", type: "searchmodal", slot: 'basic',
              subscribe: {
                'onCreate': {
                  'model': 'ProductService',
                  'inputField': 'services',
                  'target': 'service'
                },
                'onDelete': {
                  'model': 'ProductService',
                  'inputField': 'services',
                  'target': 'service'
                }
              },
              list: {
                hideNewRecordButton: true,
                hideListHeader: true,
                editPath: "services",
                objectName: "service",
                pageTitle: "Services",
                pageIcon: "store",
                listQueryId: "searchServices",
                createMutationId: "createProductService",
                deleteQueryId: "deleteProductService",
                deleteQueryIdField: "relateRecordId",
                deleteMessageTitle: "Are you sure you want to remove {objectName} from this Product?",
                deleteMessageText: "",
                linkRows: false,
                itemActions: [
                  {
                    class: "md-just-icon md-simple md-warning",
                    classAdded: "item.added? 'check_circle' : 'md-warning'",
                    icon: "post_add",
                    iconAdded: "check_circle",
                    click: "handleAdd"
                  }
                ],
                columns: {
                  name: { label: "Name", sortable: true },
                  createdAt: { label: "Created", sortable: true},
                },
                perPageOptions: [5, 10, 20, 25, 50],
                defaults: {
                  sort: 'createdAt',
                  sortDir: 'desc',
                  perPage: 10,
                },
                fuseSearch: null,
                relateRecordInput: {productServiceServiceId: null, productServiceProductId: null},
                relateRecordInputField: "productServiceServiceId",
                relateRecordRouteField: "productServiceProductId",
              },
            },
            // children: {
            //   label: "Dependencies", type: "parentchild", slot: 'basic',
            //   subscribe: {
            //     'onCreate': {
            //       'model': 'ProductChild',
            //       'inputField': 'children',
            //       'target': 'child'
            //     },
            //     'onDelete': {
            //       'model': 'ProductChild',
            //       'inputField': 'children',
            //       'target': 'child'
            //     }
            //   },
            //   hide: () => {
            //     return (this.form && this.form.productProductOptionId == "");
            //   },
            //   list: {
            //     hideNewRecordButton: true,
            //     hideListHeader: true,
            //     editPath: "products",
            //     recordDataKeyName: "children",
            //     objectName: "child",
            //     pageTitle: "Products",
            //     pageIcon: "store",
            //     listQueryId: "searchProducts",
            //     createMutationId: "createProductChild",
            //     deleteQueryId: "deleteProductChild",
            //     deleteQueryIdField: "relateRecordId",
            //     deleteMessageTitle: "Are you sure you want to remove {objectName} from this Product?",
            //     deleteMessageText: "",
            //     linkRows: false,
            //     must: [{ name: "productProductOptionId", value: "" }], //For ATLAS-624
            //     itemActions: [
            //       {
            //         class: "md-just-icon md-simple md-warning",
            //         classAdded: "item.added? 'check_circle' : 'md-warning'",
            //         icon: "post_add",
            //         iconAdded: "check_circle",
            //         click: "handleAdd"
            //       }
            //     ],
            //     columns: {
            //       name: { label: "Name", sortable: true },
            //       createdAt: { label: "Created", sortable: true},
            //     },
            //     perPageOptions: [5, 10, 20, 25, 50],
            //     defaults: {
            //       sort: 'createdAt',
            //       sortDir: 'desc',
            //       perPage: 10,
            //     },
            //     fuseSearch: null,
            //     relateRecordInput: {productChildChildId: null, parentId: null},
            //     relateRecordInputField: "productChildChildId",
            //     relateRecordRouteField: "parentId",
            //   },
            // },
            appType: { label: "Application Type", type: "select", slot: 'file_build_info', options: [], optionType: 'enum' },
            status: { label: "Status", type: "switch", slot: 'file_build_info', value: true },
            serial: { label: "Product Serial", type: "text", slot: 'equipment' },
            conversion: { label: "Conversion Type", type: "select", slot: 'equipment', options: [], optionType: 'enum' },
            notesComments: { label: "Notes Comments", type: "textarea", slot: 'equipment',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category === 'PMS_or_POS'
              }
            },
            setupFee: { label: "Setup Fee", type: "text", slot: 'equipment',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category === 'Peripheral' || this.form.category === 'PinPad' || this.form.category === 'Terminal'
              }
            },
            feeMonthlyAmount: { label: "Monthly Fee", type: "text", slot: 'equipment',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Gateway_or_Mobile'
              }
            },
            perItemFee: { label: "Per Item Fee", type: "text", slot: 'equipment',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category === 'Peripheral' || this.form.category === 'PinPad' || this.form.category === 'Terminal'
              }
            },
            billingMethod: { label: "Billing Method", type: "select", slot: 'equipment', options: [], optionType: 'enum' },
            connect: { label: "Connectivity", type: "select", slot: 'basic', options: [], optionType: 'enum',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }
            },
            encryptionKey: { label: "Encryption Key", type: "select", slot: 'equipment', options: [], optionType: 'enum',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category === 'Gateway_or_Mobile' || this.form.category === 'Peripheral' || this.form.category === 'PMS_or_POS'
              }
            },
            purchaseSwap: { label: "PinPad Purchase Swap", type: "select", slot: 'file_build_info', options: [], optionType: 'enum',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'PinPad'
              }
            },
            feeMonthly: { label: "Monthly Per Item Fee Billing", type: "select", slot: 'equipment', options: [], optionType: 'enum',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category === 'Peripheral' || this.form.category === 'PinPad' || this.form.category === 'Terminal'
              }                          
            },
            virtualTerminal: { label: "Virtual Terminal", type: "checkbox", slot: 'features',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Gateway_or_Mobile'
              }            
            },
            accountVault: { label: "Account Vault", type: "checkbox", slot: 'features',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Gateway_or_Mobile'
              }                        
            },
            recurring: { label: "Recurring", type: "checkbox", slot: 'features',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Gateway_or_Mobile'
              }                        
            },
            customerSignUp: { label: "Customer Sign Up", type: "checkbox", slot: 'features',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Gateway_or_Mobile'
              }                        
            },
            authNetEmulator: { label: "Auth Net Emulator", type: "checkbox", slot: 'features',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Gateway_or_Mobile'
              }                        
            },
            multMerchantMultiDeposit: { label: "Multi Merchant Multi Deposit", type: "checkbox", slot: 'features',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Gateway_or_Mobile'
              }                        
            },
            multiMerchantNumber: { label: "Multi Merchant Number", type: "text", slot: 'features',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Gateway_or_Mobile'
              }                            
            },
            terminalOrTsysId: { label: "Terminal ID/Tsys TID", type: "textarea", slot: 'file_build_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category === 'Peripheral' || this.form.category === 'PinPad'
              }
            },
            url: { label: "URL", type: "text", slot: 'file_build_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category === 'Peripheral' || this.form.category === 'PinPad' || this.form.category === 'PMS_or_POS'
              }
            },
            midV: { label: "MID/V#", type: "textarea", slot: 'file_build_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category === 'Peripheral' || this.form.category === 'PinPad'
              }                            
            },
            usernames: { label: "Usernames", type: "text", slot: 'file_build_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Gateway_or_Mobile'
              }                       
            },
            storeNumber: { label: "Store Number", type: "textarea", slot: 'file_build_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Gateway_or_Mobile'
              }                         
            },
            gatewayId: { label: "Gateway ID", type: "text", slot: 'file_build_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Gateway_or_Mobile'
              }                         
            },
            vendorContactNotes: { label: "Vendor Contact Info And Notes", type: "textarea", slot: 'equipment',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'PMS_or_POS'
              }                              
            },
            conversionSetupCost: { label: "Conversion Setup Cost", type: "text", slot: 'equipment',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'PMS_or_POS'
              }               
            },
            soldAmount: { label: "Sold Amount", type: "text", slot: 'equipment',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category === 'Gateway_or_Mobile' || this.form.category === 'PinPad'
              }               
            },
            warrantyReplacement: { label: "Warranty Replacement", type: "checkbox", slot: 'equipment',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category === 'Gateway_or_Mobile'
              }                          
            },
            replacementDate: { label: "Replacement Date", type: "datepicker", slot: 'equipment', format: 'YYYY-MM-DD',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category === 'Gateway_or_Mobile' || this.form.category === 'Terminal'
              }                          
            },
            isPinPad: { label: "Is Pin Pad", type: "checkbox", slot: 'equipment',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'PinPad'
              }                        
            },
            pinPadPurchaseAmount: { label: "Pin Pad Purchase Swap Sold Amount", type: "text", slot: 'equipment',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'PinPad'
              }                        
            },
            FPPPinMonthlyFee: { label: "FPP Pin Pad Monthly Fee", type: "text", slot: 'equipment',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'PinPad'
              }                        
            },
            pabx: { label: "PABX", type: "text", slot: 'equipment',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            // FPPMonthlyFee: { label: "FPP Monthly Fee", type: "text", slot: 'equipment' },
            // highSpeedType: { label: "High Speed Type", type: "select", slot: 'equipment',
            //   hide: () => {
            //     return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
            //   }                           
            // },
            staticIp: { label: "Static IP Address", type: "text", slot: 'static_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                           
            },
            dns1: { label: "DNS 1", type: "text", slot: 'static_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                           
            },
            gatewayIp: { label: "Gateway IP Address", type: "text", slot: 'static_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                       
            },
            subnet: { label: "Subnet Mask", type: "text", slot: 'static_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            dns2: { label: "DNS 2", type: "text", slot: 'static_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            secureFileCheck: { label: "Secure File", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            // secureFileFile: { label: "Secure File", type: "select", slot: 'download_info',
            //   hide: () => {
            //     return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
            //   }                         
            // },
            securityLevel: { label: "Security Level", type: "text", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            tipLine: { label: "Tip Line", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            counterTip: { label: "Counter Tip", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            serverNumer: { label: "Server Number", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            autoCloseTime: { label: "Auto Close Time", type: "datepicker", slot: 'download_info', format: 'MMM DD, YYYY',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            giftCardProvider: { label: "Gift Card Service Provider And Number", type: "text", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            ebt: { label: "EBT", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            avs: { label: "AVS", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            checkProviderNumber: { label: "Check Service Provider And Number", type: "text", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },            
            fraud: { label: "Fraud", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            merchantNumber: { label: "Merchant Number", type: "text", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            purchaseCard: { label: "Purchase Card", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            taxId: { label: "Tax ID", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            downloadPhone: { label: "Download Phone", type: "text", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            portNumber: { label: "Port Number", type: "text", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            deviceId: { label: "Device ID", type: "text", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            emvSmartCard: { label: "EMV Smart Card SC", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            nfc: { label: "NFC Contactless CTL", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            autoClose: { label: "Auto Close", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            giftCards: { label: "Gift Cards", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            internalPinPad: { label: "Pin Debit Internal Pin Pad", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            checkServices: { label: "Check Services", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            cvv2: { label: "CVV2", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            multiMerchant: { label: "Multi Merchant", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            invoiceNumber: { label: "Invoice Order Number", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            },
            customerCode: { label: "Customer Code", type: "checkbox", slot: 'download_info',
              hide: () => {
                return !this.form || typeof this.form.category === 'undefined' || this.form.category !== 'Terminal'
              }                         
            }
          },
          editTitleField: 'name'
        },
        form: {
          id: "",
          name: "",
          description: "",
          category: "",
          productProductOptionId: "",
          // productServiceId: "",
          status: true,
          productAccountId: "",
          productBillToServiceId: "",
          billingMethod: "",
          serial: "",
          platform: "",
          appType: "",
          connect: "",
          conversion: "",
          encryptionKey: "",
          purchaseSwap: "",
          feeMonthly: "",
          feeMonthlyAmount: "",
          cashDiscount: "",
          owner: "",
          virtualTerminal: "",
          accountVault: "",
          recurring: "",
          customerSignUp: "",
          authNetEmulator: "",
          multMerchantMultiDeposit: "",
          multiMerchantNumber: "",
          notesComments: "",
          setupFee: "",
          perItemFee: "",
          terminalOrTsysId: "",
          midV: "",
          storeNumber: "",
          url: "",
          usernames: "",
          gatewayId: "",
          vendorContactNotes: "",
          conversionSetupCost: "",
          soldAmount: "",
          warrantyReplacement: "",
          replacementDate: null,
          isPinPad: "",
          pinPadPurchaseAmount: "",     
          FPPPinMonthlyFee: "",
          pabx: "",
          // highSpeedType: "",
          staticIp: "",
          dns1: "",
          gatewayIp: "",
          subnet: "",
          dns2: "",
          secureFileCheck: "",
          // secureFileFile: "",
          securityLevel: "",
          tipLine: "",
          counterTip: "",
          serverNumer: "",
          autoCloseTime: null,
          giftCardProvider: "",
          ebt: "",
          avs: "",
          checkProviderNumber: "",
          fraud: "",
          merchantNumber: "",
          purchaseCard: "",
          taxId: "",
          downloadPhone: "",                    
          portNumber: "",
          deviceId: "",
          emvSmartCard: "",
          nfc: "",
          autoClose: "",                    
          giftCards: "",
          internalPinPad: "",
          checkServices: "",
          cvv2: "",
          multiMerchant: "",                    
          invoiceNumber: "",
          customerCode: "",
          services: [],
          children: []
        },
        categoryOptions: [],
        billingMethodOptions: [],
        platformOptions: [],
        appTypeOptions: [],
        connectOptions: [],
        conversionOptions: [],
        encryptionKeyOptions: [],
        purchaseSwapOptions: [],
        feeMonthlyOptions: [],
        parentProductsList: [],
        getProductChildItems: [],
        loadProductOptions: [],
        casesList: {
          listQueryId: "searchCaseProductsCustom",
          listQueryTarget: "searchCaseProducts",
          responseFieldName: "searchCaseProducts",
          deleteQueryId: "deleteCaseProduct",
          filterListQueryId: "getListCaseStatusEnum",
          relateRecordInputField:"caseProductCaseId",
          createMutationId: "createCaseProduct",
          caseFromTab: 'Product',
          isSearchRecordsInput: true,
        },
        tasksList: {
          listQueryId: "searchTaskProducts",
          responseFieldName: "searchTaskProducts",
          deleteQueryId: "deleteTaskProduct",
          filterListQueryId: "getListTaskStatusEnum",
          // caseMapIdFilter: {"taskProductProductId": {"eq": this.$route.params.id }}
        },

        productParentList: {
          linkActive: true,
          showRelatedDialog: false,
          btnLabel: "Add",
          showRelatedLinkDialog: false,
          hideListHeader: false,
          linkRows: true,
          editPath: "products",
          pageTitle: "Parents",
          listQueryId: "searchProductChildCustoms",
          responseFieldName: "searchProductChilds",
          deleteQueryId: "deleteProductChild",
          deleteQueryIdField: "productChildId",
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this Product?",
          deleteMessageText: "",
          deleteMessageNameFields: ['name'],
          disableLinkActive: true, //for delete action
          must: [{ name: "productAccountId", value: "" }],
          itemActions: [
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          columns: {
            'esData.parent.productOption.name': { label: "Type", sortable: false, esNested: true},
            'esData.parent.name': { label: "Product", sortable: false, esNested: true},
          },
          perPageOptions: [5, 10, 25, 50],
          defaults: {
            sort: "createdAt",
            sortDir: "desc",
            perPage: 10,
          },
          tableData: [],
          searchedData: [],
          fuseSearch: null,
          skipProductParents: [],
          //includeProductOptions: [],
          addRelatedParentProduct: [],
          formatResponse: (data) => {
            let result = [];
            let parentProductArr = [];
            //this.parentProductsList = []; //reset

            if (data && data.searchProductChilds && data.searchProductChilds.items && data.searchProductChilds.items.length) {
              console.log("items ===> ", data.searchProductChilds.items);

              data.searchProductChilds.items.forEach((item) => {
                    item.productOptionName = (item.productOption && item.productOption.name)? item.productOption.name : '';
                    item.productChildId = item.id;
                    //item.name = item.parent.name;
                    result.push(item);
                    this.productParentList.skipProductParents.push(item.parentId);
              });
            }
            return result;
          }
        },
        relateProductParentList: {
          //isOfflineSearchEnabled: true,
          //searchRecordsInput: false, //disable search input
          hideListHeader: true,
          skipCardLayout: true,
          editPath: "products",
          pageTitle: "Search for Products",
          pageIcon: "store",
          listQueryId: "searchProductsChildrens",
          responseFieldName: "searchProducts",
          createMutationId: "createProductChild",
          relateRecordInput: {productChildChildId: null, parentId: null},
          relateRecordInputField: "parentId",
          relateRecordRouteField: "productChildChildId",
          relateRecordInputParentId: "productChildParentId",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "handleAdd"
            }
          ],
          columns: {
            name: { label: "Name", sortable: true },
            createdAt: { label: "Created", sortable: true},
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];

            if (data && data.searchProducts && data.searchProducts.items && data.searchProducts.items.length) {
              data.searchProducts.items.forEach((item) => {
                result.push(item);
              });
            }
            return result;
          }
        },
        productChildList: {
          linkActive: true,
          showRelatedDialog: false,
          btnLabel: "Add",
          showRelatedLinkDialog: false,
          showAddNewModal: false,
          hideListHeader: false,
          linkRows: true,
          editPath: "products",
          pageTitle: "Dependencies",
          listQueryId: "searchProductChildCustoms",
          responseFieldName: "searchProductChilds",
          deleteQueryId: "deleteProductChild",
          deleteQueryIdField: "productChildId",
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this Product?",
          deleteMessageText: "",
          deleteMessageNameFields: ['name'],
          disableLinkActive: true, //for delete action
          itemActions: [
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          columns: {
            'esData.child.productOption.name': { label: "Type", sortable: false, esNested: true},
            'esData.child.name': { label: "Product", sortable: false, esNested: true},
          },
          perPageOptions: [5, 10, 25, 50],
          defaults: {
            sort: "createdAt",
            sortDir: "desc",
            perPage: 10,
          },
          tableData: [],
          searchedData: [],
          fuseSearch: null,
          skipProductChilds: [],
          includeProductOptions: [],
          addRelatedChildProduct: [],
          addProductAccountInModal: {},
          formatResponse: (data) => {
            let result = [];

            if (data && data.searchProductChilds && data.searchProductChilds.items && data.searchProductChilds.items.length) {
              console.log("items ===> ", data.searchProductChilds.items);
              data.searchProductChilds.items.forEach((item) => {
                item.productOptionName = (item.productOption && item.productOption.name)? item.productOption.name : '';
                item.productChildId = item.id;
                //item.name = item.parent.name;
                result.push(item);
                this.productChildList.skipProductChilds.push(item.child.id);
              });
            }
            return result;
          }
        },
        relateProductChildList: {
          //isOfflineSearchEnabled: true,
          //searchRecordsInput: false, //disable search input
          hideListHeader: true,
          skipCardLayout: true,
          editPath: "products",
          pageTitle: "Search for Products",
          pageIcon: "store",
          listQueryId: "searchRelatedProducts",
          responseFieldName: "searchProducts",
          createMutationId: "createProductChild",
          relateRecordInput: {productChildChildId: null, parentId: null},
          relateRecordInputField: "productChildChildId",
          relateRecordRouteField: "parentId",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "handleAdd"
            }
          ],
          columns: {
            name: { label: "Name", sortable: true },
            createdAt: { label: "Created", sortable: true},
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];

            if (data && data.searchProducts && data.searchProducts.items && data.searchProducts.items.length) {
              data.searchProducts.items.forEach((item) => {
                result.push(item);
              });
            }
            return result;
          }
        },
        subscriptions: {
          'onCreateProductChild': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onCreateProductChild');
              this.$c.log("eventData: ", eventData);
              let eventRecord = eventData.value.data.onCreateProductChild;

              if (this.$route.params.id === eventRecord.parentId) {
                this.$c.log('SUBSCRIPTION MATCH!: onCreateProductChild');
                //refresh the list
                window.setTimeout(() => {
                  this.$refs.productChildListRef.refresh();
                }, 3000);
              } else if (this.$route.params.id === eventRecord.child.id) {
                this.$c.log('SUBSCRIPTION MATCH!: onCreateProductChild');
                //refresh the list
                window.setTimeout(() => {
                  this.$refs.productParentListRef.refresh();
                }, 3000);
              }
              //Force a refresh on the ConfigForm component
              this.formConfig.refreshRecordData = true;
            }
          }
        }
      }
    },
    watch: {
    "$v.form.category.$model": function(oldVal, newVal) {      
        (($this) => {             
          if(newVal && oldVal !== newVal) {
            //clean the search on Category change
            $this.searchTerm = '';
            $this.options = new Promise(resolve => resolve([]));     
            this.form.productProductOptionId = '';

            //add filter on ProductOption field based on changed Category
            this.formConfig.fields.productProductOptionId.lazyLoadFilter = {
              bool: {
                  should: [
                    {
                      match_phrase: {
                        category: oldVal,
                      }
                    }
                  ]
                }
            }
          }     
        })(this.formConfig.fields.productProductOptionId);                         
      },
    "$v.form.productAccountId.$model": function(oldVal, newVal) { 
        (($this) => {        
          if(newVal && oldVal !== newVal) {
            $this.searchTerm = '';            
            // this.form.services = [];
          }
          // if we don't have productAccountId then clear productBillToServiceId
          if (!oldVal) {
            (($this) => {
              $this.data = [];
              this.form.productBillToServiceId = '';
            })(this.formConfig.fields.productBillToServiceId);
          }
          // whenever productAccountId changes reset productBillToServiceId filter
          if (oldVal !== newVal) {
            this.getProductBillToServiceIdFilter();
          }
        })(this.formConfig.fields.productBillToServiceId);
      },
      /**
       * ATLAS-624 Product Dependencies - part 2 -
       * Require product selection on front end based on dependencies
       * 
       * Get child items for selected ProductOption to pass SearchModalParentChild CRUD input
       */
      "$v.form.productProductOptionId.$model": {
        immediate: true,
        handler: function() {
          if (this.form.productProductOptionId) {
            this.loadDependencies();
          }
        }
      },
      /**
       * ATLAS-1012: <Product Option> <Side Panel> Product Dependencies
       * Refresh the PO List on route change
       */
      '$route.params.id': function () {
        window.setTimeout(() => {
          this.$refs.productParentListRef.refresh();
          this.$refs.productChildListRef.refresh();
        }, 400);
      },
      "productParentList.skipProductParents": {
        immediate: true,
        handler: function() {
          this.getDependenciesCount();
        }
      },
      "productChildList.skipProductChilds": {
        immediate: true,
        handler: function() {
          this.getDependenciesCount();
        }
      }
    },
    validations() {           
      return {
        form: {
          id: {},
          name: {required, minLength: minLength(3)},
          description: {},
          category: {required},
          productProductOptionId: {required},
          // productServiceId: {},
          services: {},
          children: {},
          status: {},
          productAccountId: {required},
          productBillToServiceId: (this.form && (this.form.category === 'PMS_or_POS' || this.form.category === 'Terminal')) ? {required} : {},
          billingMethod: (this.form && (this.form.category === 'PMS_or_POS' || this.form.category === 'Terminal' || this.form.category === 'PinPad' )) ? {required} : {},
          serial: (this.form && (this.form.category === 'PinPad' || this.form.category === 'Terminal' )) ? {required} : {},
          platform: (this.form && (this.form.category === 'PMS_or_POS' || this.form.category === 'Terminal' || this.form.category === 'Gateway_or_Mobile' )) ? {required} : {},
          appType: (this.form && (this.form.category === 'Terminal' || this.form.category === 'Gateway_or_Mobile' )) ? {required} : {},
          connect: (this.form && this.form.category === 'Terminal') ? {required} : {},
          conversion: (this.form && this.form.category === 'PMS_or_POS') ? {required} : {},
          encryptionKey: (this.form && this.form.category === 'PinPad') ? {required} : {},
          purchaseSwap: (this.form && this.form.category === 'PinPad') ? {required} : {},
          feeMonthly: (this.form && this.form.category === 'Gateway_or_Mobile') ? {required} : {},
          feeMonthlyAmount: {},
          cashDiscount: {},
          owner: {},
          virtualTerminal: {},
          accountVault: {},
          recurring: {},
          customerSignUp: {},
          authNetEmulator: {},
          multMerchantMultiDeposit: {},
          multiMerchantNumber: {},
          notesComments: {},
          setupFee: {},
          perItemFee: {},
          terminalOrTsysId: {},      
          midV: {},
          storeNumber: {},
          url: {},
          usernames: {},
          gatewayId: {},
          vendorContactNotes: {},
          conversionSetupCost: {},
          soldAmount: {},
          warrantyReplacement: {},
          replacementDate: {},
          isPinPad: {},
          pinPadPurchaseAmount: {},                    
          FPPPinMonthlyFee: {},
          pabx: {},
          // highSpeedType: {},
          staticIp: {},
          dns1: {},
          gatewayIp: {},
          subnet: {},
          dns2: {},
          secureFileCheck: {},
          // secureFileFile: {},
          securityLevel: {},
          tipLine: {},  
          counterTip: {},
          serverNumer: {},
          autoCloseTime: {},
          giftCardProvider: {},
          ebt: {},
          avs: {},
          checkProviderNumber: {},
          fraud: {},  
          merchantNumber: {},
          purchaseCard: {},
          taxId: {},
          downloadPhone: {},
          portNumber: {},
          deviceId: {},
          emvSmartCard: {},
          nfc: {},    
          autoClose: {},
          giftCards: {},
          internalPinPad: {},
          checkServices: {},
          cvv2: {},
          multiMerchant: {},
          invoiceNumber: {},
          customerCode: {}   

        },
      }    
    },
    methods: {
      updateFormAfter(data) {
        if (typeof data === 'undefined') return;

        //ATLAS-1245: get Product dependencies from getProduct query
        if (data.getProduct && data.getProduct.children && data.getProduct.children.items) {
          this.getProductChildItems = data.getProduct.children.items;
        }

        this.getCategoryEnumOptions(data);
        this.getBillingMethodEnumOptions(data);
        this.getPlatformEnumOptions(data);
        this.getAppTypeEnumOptions(data);
        this.getConnectEnumOptions(data);
        this.getConversionEnumOptions(data);
        this.getEncryptionKeyEnumOptions(data);
        this.getPurchaseSwapEnumOptions(data);
        this.getFeeMonthlyEnumOptions(data);

        // (($this) => {
        //   $this.data = data.listServices.items;
        //   if (this.recordData && this.recordData.service) {
        //     $this.searchTerm = this.recordData.service.name;
        //     this.form.productServiceId = this.recordData.service.id;
        //   } 
        // })(this.formConfig.fields.productServiceId); 

        // Update the productProductOptionId auto-complete
        (($this) => {
          $this.data = data.listProductOptions.items;

          /**
           * ATLAS-1246: <DM>When viewing a Product, the Account and ProductOption field is not showing
           * the associated value after migrated record (even though the db has a value)
           * 
           * Add Product's ProductOption entry in the productoptions list
           * if not exist in query result - data.listProductOptions.items
           */
          let isSetProductProductOption = true;
          let productProductOptionObj = {};
          data.listProductOptions.items.forEach(el => {
            if (data.getProduct && data.getProduct.productoption && data.getProduct.productoption.id && data.getProduct.productoption.id === el.id) {
              isSetProductProductOption = false;
            }
          });

          if (isSetProductProductOption) {
            if (data.getProduct && data.getProduct.productOption && data.getProduct.productOption.id) {
              productProductOptionObj = {
                id: data.getProduct.productOption.id,
                name: data.getProduct.productOption.name,
                status: data.getProduct.productOption.status,
                category: data.getProduct.productOption.category,
                children: data.getProduct.productOption.children
              };
              $this.data.push(productProductOptionObj);
            }
          }

          //ATLAS-624: create available ProductOptions list
          this.form.productOptionsList = $this.data;

          //empty list
          $this.data = [];
          if (this.recordData && this.recordData.productOption) {
            this.form.category = this.recordData.productOption.category;
            $this.searchTerm = this.recordData.productOption.name;            
            this.form.productProductOptionId = this.recordData.productOption.id;
          } 
          if (this.form.productProductOptionId) {
            this.loadDependencies();
          }
        })(this.formConfig.fields.productProductOptionId); 

        // Update the productAccountId auto-complete
        (($this) => {
          //$this.data = data.listAccounts.items;
          $this.data = [];

          /**
           * ATLAS-522: Add Product from Account
           * Default select Account on page load when redirected to New Product page
           */
          if(this.$route.query.productAccountId) {
            $this.data.forEach(item => {
              if(item.id == this.$route.query.productAccountId) {
                $this.searchTerm = item.name;
                this.form.productAccountId = item.id;
              }
            });
          }

          //ATLAS-1262: get Account data to pass on AddProductModal popup
          if (data.getProduct && data.getProduct.account && data.getProduct.account.id) {
            this.productChildList.addProductAccountInModal = {
              id: data.getProduct.account.id,
              name: data.getProduct.account.name
            }
          }

          if (this.recordData && this.recordData.account) {
            $this.searchTerm = this.recordData.account.name;
            this.form.productAccountId = this.recordData.account.id;

            //set productAccountId for productParentList must filter
            this.productParentList.must.forEach(e => {
              e.value = this.form.productAccountId;
            });
          }
        })(this.formConfig.fields.productAccountId);
        
        (($this) => {
          $this.data = [];
          if (this.recordData && this.recordData.billToService) {
            $this.searchTerm = this.recordData.billToService.name;
            this.form.productBillToServiceId = this.recordData.billToService.id;
          } 
        })(this.formConfig.fields.productBillToServiceId);       
        
        if (this.recordData) {
          if (this.recordData.replacementDate) {
            this.$v.form.replacementDate.$model = new Date(this.recordData.replacementDate);
          }
          if (this.recordData.autoCloseTime) {
            this.$v.form.autoCloseTime.$model = new Date(this.recordData.autoCloseTime);
          }          
        }

        this.loadRelatedRecords(data, 'services', 'service');
        this.loadRelatedRecords(data, 'children', 'child');
        this.getProductBillToServiceIdFilter();

      },

      loadDependencies() {
        const origPOList = this.form.productOptionsList;
        let POList = [];
        
        origPOList.forEach ((_element, _elementIndex) => {
          if(
            _element.id == this.form.productProductOptionId &&
            _element.children && _element.children.items &&
            _element.children.items.length
          ) {
            POList = _element.children.items;
          }
        });
        this.form.childProductOptionsList = POList;

        //Children Field UI fix: added this to refresh the vue-grid-layout on form change
        window.setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 500);
      },

      loadRelatedRecords(data, name, target) {
        let result = [];
        if (data && data.getProduct && data.getProduct[name] && data.getProduct[name].items && data.getProduct[name].items.length) {
          let items = data.getProduct[name].items;
          items.forEach(item => {
            if(item[target]){
              item[target].relateRecordId = item.id;
              result.push(item[target]);
            }

          });
        }
        this.form[name] = result;
      },

      getCategoryEnumOptions(data) {
        this.categoryOptions = [];
        if (data.listProductCategoryEnum && data.listProductCategoryEnum.enumValues) {
          data.listProductCategoryEnum.enumValues.map(_value => {
            this.categoryOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.category.options = this.categoryOptions;
        }
      },        
      
      getBillingMethodEnumOptions(data) {
        this.billingMethodOptions = [];
        if (data.listProductBillingMethodEnum && data.listProductBillingMethodEnum.enumValues) {
          data.listProductBillingMethodEnum.enumValues.map(_value => {
            this.billingMethodOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.billingMethod.options = this.billingMethodOptions;
        }
      },        
      
      getPlatformEnumOptions(data) {
        this.platformOptions = [];
        if (data.listProductPlatformEnum && data.listProductPlatformEnum.enumValues) {
          data.listProductPlatformEnum.enumValues.map(_value => {
            this.platformOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.platform.options = this.platformOptions;
        }
      },      

      getAppTypeEnumOptions(data) {
        this.appTypeOptions = [];
        if (data.listProductAppTypeEnum && data.listProductAppTypeEnum.enumValues) {
          data.listProductAppTypeEnum.enumValues.map(_value => {
            this.appTypeOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.appType.options = this.appTypeOptions;
        }
      },     

      getConnectEnumOptions(data) {
        this.connectOptions = [];
        if (data.listProductConnectEnum && data.listProductConnectEnum.enumValues) {
          data.listProductConnectEnum.enumValues.map(_value => {
            this.connectOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.connect.options = this.connectOptions;
        }
      },  

      getConversionEnumOptions(data) {
        this.conversionOptions = [];
        if (data.listProductConversionEnum && data.listProductConversionEnum.enumValues) {
          data.listProductConversionEnum.enumValues.map(_value => {
            this.conversionOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.conversion.options = this.conversionOptions;
        }
      },  

      getEncryptionKeyEnumOptions(data) {
        this.encryptionKeyOptions = [];
        if (data.listProductEncryptionKeyEnum && data.listProductEncryptionKeyEnum.enumValues) {
          data.listProductEncryptionKeyEnum.enumValues.map(_value => {
            this.encryptionKeyOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.encryptionKey.options = this.encryptionKeyOptions;
        }
      },  

      getPurchaseSwapEnumOptions(data) {
        this.purchaseSwapOptions = [];
        if (data.listProductPurchaseSwapEnum && data.listProductPurchaseSwapEnum.enumValues) {
          data.listProductPurchaseSwapEnum.enumValues.map(_value => {
            this.purchaseSwapOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.purchaseSwap.options = this.purchaseSwapOptions;
        }
      },  

      getFeeMonthlyEnumOptions(data) {
        this.feeMonthlyOptions = [];
        if (data.listProductFeeMonthlyEnum && data.listProductFeeMonthlyEnum.enumValues) {
          data.listProductFeeMonthlyEnum.enumValues.map(_value => {
            this.feeMonthlyOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.feeMonthly.options = this.feeMonthlyOptions;
        }
      },

      async getParentProductChild(itemId, queryId, fieldLabel, fieldId) {
        await API.graphql(graphqlOperation(queries_custom[queryId], {id : itemId}))
          .then(result => {
            console.log(result);
            result.data.getProduct[fieldLabel] = fieldId;
            this.parentProductsList.push(result.data.getProduct);
          })
          .catch(error => {
            console.log(error);
          });
      },
      /**
       * @description
       * Update productBillToServiceId filter list to show services from
       * linked account
       * @see https://zeamster.atlassian.net/browse/ATLAS-1397
       * @returns {Void}
       */
      async getProductBillToServiceIdFilter() {
        const queryId = 'searchServices';
        const productAccountId = this.$v.form.productAccountId.$model;
        const filter = { serviceAccountId: { eq: productAccountId } };
        const negativeLazyLoadFilter = {
          bool: {
            should: [
              { match_phrase: { id: -1 } },
            ],
          },
        };
        
        if (!productAccountId) {
          this.formConfig.fields.productBillToServiceId.lazyLoadFilter = negativeLazyLoadFilter;
          return negativeLazyLoadFilter;
        }
        
        API.graphql(graphqlOperation(queries[queryId], { filter, limit: 999 }))
          .then(res => {
            // get items - bail if not items
            const items = res.data[queryId].items;
            
            // no items in list - set negative filter
            if (!items || !items.length) {
              this.formConfig.fields.productBillToServiceId.lazyLoadFilter = negativeLazyLoadFilter;
              return;
            }
            
            // prepare or filter for services
            const idFilters = [];
            items.forEach((service) => {
              if (!service || !service.id) {
                return;
              }
              idFilters.push({ match_phrase: { id: service.id } });
            });
            
            // update lazy load filter
            const lazyLoadFilter = { bool: { should: idFilters } };
            this.formConfig.fields.productBillToServiceId.lazyLoadFilter = lazyLoadFilter;
          })
          .catch(err => {
            console.log(err);
          });
      },
      getDependenciesCount() {
        //using refs due to elastic list component
        let productParentLength = 0;
        let productChildLength = 0;
        if (this.$refs && this.$refs.productParentListRef && this.$refs.productParentListRef.activeData && this.$refs.productParentListRef.activeData.items) {
          productParentLength = this.$refs.productParentListRef.activeData.items.length;
        }
        if (this.$refs && this.$refs.productChildListRef  && this.$refs.productChildListRef.activeData && this.$refs.productChildListRef.activeData.items) {
          productChildLength = this.$refs.productChildListRef.activeData.items.length;
        }
        let totalCount = productParentLength + productChildLength;
        window.$bus.$emit("badge-changed", 'dependents', totalCount);
      }
    }
  }
</script>

<style lang="scss">

  .md-tabs .md-tabs-navigation {
    padding-left: 15px;
    color: black;
    display: none;

    .md-tab-nav-button.md-button {
      color: black !important;

      &.active {
        color: black !important;
        border-bottom: 2px solid black;
      }
    }
  }

  .md-content .md-tabs-container .md-tab > .md-layout-item {
    padding-left: 0;
    padding-right: 0;
  }

  [name="giftCardProvider"] {
    margin-top: 16px;
  }
  
  .form-field-view.search-modal-header {
    font-weight: 500;
  }
  
  .isEditing .form-field-view.search-modal-header {
    font-weight: normal;
  }
</style>
